export default __webpack_public_path__ + "static/jake-archibald-205631ab8e9cee5b4685e71b6a64ed7e.jpg";